export const feedbackIconMapping = {
  success: 'mdi:success-circle',
  danger: 'codicon:error',
  warning: 'mdi:warning-circle-outline'
}

export const confirmationIconMapping = {
  primary: 'mdi:help-circle',
  danger: 'mdi:warning',
  warning: 'mdi:warning-circle-outline'
}

export const buttonColorStatusMapping: Record<string, 'error' | 'primary' | 'success' | 'warning' | 'info'> = {
  danger: 'error',
  primary: 'primary',
  success: 'success',
  warning: 'warning',
  info: 'info'
}
